<template>
  <b-container class="main-container">
    <b-row>
      <b-col>
        <h3 v-if="opportunity">
          {{title}}
          <b-button variant="primary" v-if="isOpportunitiesManager" class="pull-right ml-2" :to="{name: 'opportunityEdit', params: {opportunityId: opportunity.opportunityId}}">Edit</b-button>

          <b-button variant="primary" v-if="isOpportunitiesManager" class="pull-right ml-2" @click="deleteOpportunity">Delete</b-button>

          <opportunity-publish class="pull-right ml-2" v-if="isOpportunitiesManager" :id="opportunity.opportunityId" :state="opportunity.published" :disabled="!opportunity.published && !opportunity.canPublish" @updated="load"/>
        </h3>
        <h4 v-if="opportunity && opportunity.name">{{ opportunity.name }}</h4>
        <b-alert variant="warning" :show="opportunity && !opportunity.published && !opportunity.canPublish">This opportunity cannot be published yet. Please ensure all contract requirements are met.</b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="9">

        <widget>
          <opportunity-details :opportunity="opportunity" v-if="opportunity" :applicationTypes="applicationTypes" @delete="deleteOpportunity"></opportunity-details>
        </widget>

        <widget :heading="'About ' + opportunity.site.name" v-if="opportunity">
          <show-more :text="opportunity.site.description" v-if="opportunity.site.description"></show-more>
        </widget>

        <widget heading="Files">
          <opportunity-files :opportunityId="opportunityId"></opportunity-files>
        </widget>

        <widget heading="Contracts">
          <site-contracts :contracts="contracts"></site-contracts>
        </widget>

      </b-col>
      <b-col sm="3">
        <widget heading="Opportunity Contacts">
           <site-contacts :contacts="siteContacts"
                           :siteId="opportunity.siteId"
                           opportunity
                           v-if="opportunity"></site-contacts>
        </widget>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import OpportunityDetails from "../../components/opportunities/opportunity-details";
import OpportunityFiles from "../../components/opportunities/opportunity-files";
import OpportunityPublish from "../../components/opportunities/opportunity-publish";
import StudentActions from "../../components/sites/student-actions";
import AdditionalMaterials from "../../components/opportunities/additional-materials";
import SiteContacts from "../../components/sites/site-contacts";
import ShowMore from "../../components/show-more";
import Widget from "../../components/widget";
import opportunitiesApi from "../../api/opportunity";
import applicationTypesApi from "../../api/applicationTypes";
import SiteContracts from "../../components/sites/site-contracts";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import roleChecks from "../../misc/role-checks";

var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  mixins: [roleChecks],

  data() {
    return {
      opportunity: null,
      applicationTypes: []
    };
  },

  props: {
    opportunityId: {
      required: true
    }
  },

  computed: {
    title: function() {
      return (
        // (this.opportunity ? this.opportunity.opportunityCategory.name : "") +

        (this.opportunity.translationalTeam
          ? this.opportunity.translationalTeam.name + " @ "
          : "") + (this.opportunity ? this.opportunity.site.name : "")
      );
    },
    studentActions: function() {
      if (this.opportunity) {
        return _.map(
          this.opportunity.opportunityStudentActions,
          "studentAction"
        );
      }
      return [];
    },

    siteContacts: function() {
      if (this.opportunity) {
        return _.map(this.opportunity.opportunitySiteContacts, "siteContact");
      }
      return [];
    },

    contracts: function() {
      if (this.opportunity) {
        return _.map(this.opportunity.site.contractSites, function(
          contractSite
        ) {
          return contractSite.contract;
        });
      }
      return [];
    }
  },

  methods: {
    getDecodedHtml(rawHtml) {
      if (rawHtml) {
        return htmlDecode(rawHtml);
      }
      return "";
    },

    deleteOpportunity() {
      var that = this;
      opportunitiesApi
        .deleteOpportunity(this.opportunityId)
        .then(function() {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("Opportunity deleted.", "Success");

          // navigate back to opportunities list
          that.$router.push({ name: "opportunities" });
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    load() {
      opportunitiesApi
        .getOpportunity(this.opportunityId)
        .then(response => {
          this.opportunity = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  components: {
    "opportunity-details": OpportunityDetails,
    "opportunity-files": OpportunityFiles,
    "student-actions": StudentActions,
    "additional-materials": AdditionalMaterials,
    "site-contacts": SiteContacts,
    "show-more": ShowMore,
    widget: Widget,
    "site-contracts": SiteContracts,
    OpportunityPublish
  },

  created() {
    var that = this;
    this.load();
    applicationTypesApi
      .getApplicationTypes()
      .then(function(response) {
        that.applicationTypes = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
.main-container {
  max-width: 100%;
  margin-top: 10px;
}

.widget-body {
  font-size: 13px;
}
</style>
